import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getSharedDocumentBlob } from "services/publicService";

const SharedDocumentView = () => {
  const {
    projectId = "",
    resourceId = "",
    token = "",
  } = useParams<{ projectId: string; resourceId: string; token: string }>();
  const [fileUrl, setFileUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!projectId || !resourceId || !token) return;
    let cancelled = false;
    let objectUrl: string | null = null;
    getSharedDocumentBlob(projectId, resourceId, token).then((res) => {
      if (cancelled) return;
      objectUrl = URL.createObjectURL(res.data);
      setFileUrl(objectUrl);
    });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [projectId, resourceId, token]);

  if (!fileUrl) return null;

  return (
    <iframe
      title="Shared document"
      src={fileUrl}
      style={{ position: "fixed", inset: 0, width: "100%", height: "100%", border: "none" }}
    />
  );
};

export default SharedDocumentView;
